import apiClient from './apiClient'


const getContacts = (tenant, skip, take, search) => {
  const params = {
    skip,
    take,
    keyword: search
  }
  return apiClient.get(`/${tenant}/Contact`, { params })
}

const getContactsShort = (tenant, search) => {
  const params = {
    keyword: search
  }
  return apiClient.get(`/${tenant}/Contact/Short`, { params })
}

const getContactsPhones = (tenant) => {
  return apiClient.get(`/${tenant}/Contact/Phones`)
}

const getContactById = (tenant, id) => {
  return apiClient.get(`/${tenant}/Contact/${id}`)
}

const createContact = (tenant, contact) => {
  return apiClient.post(`/${tenant}/Contact`, contact)
}

const mergeContact = (tenant, contact) => {
  return apiClient.put(`/${tenant}/Contact/${contact.id}/Merge`, contact)
}

const updateContact = (tenant, id, contact) => {
  return apiClient.put(`/${tenant}/Contact/${id}`, contact)
}

const deleteContact = (tenant, id) => {
  return apiClient.delete(`/${tenant}/Contact/${id}`)
}

const addLabelToContact = (tenant, contactId, labelId) => {
  return apiClient.post(`/${tenant}/Contact/${contactId}/Label/${labelId}`)
}

const removeLabelFromContact = (tenant, contactId, labelId) => {
  return apiClient.delete(`/${tenant}/Contact/${contactId}/Label/${labelId}`)
}

const getAddressTypes = (tenant) => {
  return apiClient.get(`/${tenant}/Contact/AddressTypes`)
}

const getEmailTypes = (tenant) => {
  return apiClient.get(`/${tenant}/Contact/EmailTypes`)
}

const getPhoneTypes = (tenant) => {
  return apiClient.get(`/${tenant}/Contact/PhoneTypes`)
}

const getRelations = (tenant, contactId) => {
  return apiClient.get(`/${tenant}/Contact/${contactId}/Relations`)
}

const getDuplicates = (tenant, contactId) => {
  return apiClient.get(`/${tenant}/Contact/${contactId}/Duplicates`)
}

const getUniqueEmail = (tenant, email) => {
  const params = {
    email
  }
  return apiClient.get(`/${tenant}/Contact/UniqueEmail`, { params })
}

const putEncryptionPassword = (tenant, payload) => {
  return apiClient.put(`/${tenant}/Contact/${payload.id}/EncryptPassword`, payload)
}

export default {
  getContacts,
  getContactsShort,
  getContactsPhones,
  getContactById,
  createContact,
  mergeContact,
  updateContact,
  deleteContact,
  addLabelToContact,
  removeLabelFromContact,
  getAddressTypes,
  getEmailTypes,
  getPhoneTypes,
  getRelations,
  getDuplicates,
  getUniqueEmail,
  putEncryptionPassword
}
